'use client'

import { clsx } from 'clsx'
import { type FC, useEffect, useState } from 'react'
import { FormattedMessage } from 'react-intl'

import { Tab, TabPanel, Tabs, TabsList } from 'base-ui'

import { useUrlHash } from '../../../generic-hooks'

import { ProductFaqs } from './ProductFaqs'
import { ProductReviews } from './ProductReviews'

export const ProductFaqAndReviewsTabs: FC<{
  className?: string
  faqsSectionId: string
  reviewsSectionId: string
}> = ({ className, faqsSectionId, reviewsSectionId }) => {
  const [selected, setSelected] = useState(faqsSectionId)

  const [hash] = useUrlHash()

  useEffect(() => {
    if (hash === `#${faqsSectionId}`) {
      // eslint-disable-next-line react-hooks/set-state-in-effect -- don't reference, refactor if touched
      setSelected(faqsSectionId)
    }
    if (hash === `#${reviewsSectionId}`) {
      setSelected(reviewsSectionId)
    }
  }, [faqsSectionId, hash, reviewsSectionId])

  return (
    <div className={clsx('mt-10', className)}>
      <div className="scroll-mt-4" id={faqsSectionId} />
      <div className="scroll-mt-4" id={reviewsSectionId} />
      <Tabs
        onChange={(event, value): void => {
          if (typeof value === 'string') {
            setSelected(value)
          }
        }}
        value={selected}
      >
        <TabsList>
          <Tab value={faqsSectionId}>
            <FormattedMessage id="general.label.product.Questions" />
            <span className="hidden tablet:inline">
              {' '}
              <FormattedMessage id="general.label.product.AndAnswers" />
            </span>
          </Tab>
          <Tab data-qa-id="product-review-tab" value={reviewsSectionId}>
            <FormattedMessage id="footer.links.label.productReviews" />
          </Tab>
        </TabsList>
        <TabPanel value={faqsSectionId}>
          <ProductFaqs />
        </TabPanel>
        <TabPanel value={reviewsSectionId}>
          <ProductReviews />
        </TabPanel>
      </Tabs>
    </div>
  )
}
